module.exports = __webpack_public_path__ + "static/media/peixe-capa.78d35c8c.png";